// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_trapezoidal_strap/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_trapezoidal_strap: ModuleSchema = {
  "id": "core_trapezoidal_strap",
  "uniqueId": "B3D_STP01",
  "createdAt": "2026-10-11T05:00:00Z",
  "updatedAt": "2026-10-11T09:57:51.693Z",
  "label": "Trapezoidal Strap",
  "description": "Standalone core geometry module for trapezoidal fanned ribbon strap (CG_STRP01)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_STRP01",
    "trapezoid-strap",
    "ribbon"
  ],
  "sliders": [
    {
      "key": "topWidth",
      "label": "Top Width (mm)",
      "min": 4,
      "max": 16,
      "default": 8,
      "step": 0.5,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "bottomWidth",
      "label": "Bottom Width (mm)",
      "min": 6,
      "max": 30,
      "default": 15,
      "step": 0.5,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "length",
      "label": "Length (mm)",
      "min": 20,
      "max": 150,
      "default": 80,
      "step": 2,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "thickness",
      "label": "Thickness (mm)",
      "min": 0.4,
      "max": 3,
      "default": 0.8,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "fanAngleDeg",
      "label": "Fan Out Angle (deg)",
      "min": -30,
      "max": 30,
      "default": 0,
      "step": 1,
      "unit": "°",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "strap",
      "label": "Strap Color",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "trapezoidal_strap",
      "name": "Trapezoidal Strap Solid",
      "parts": [
        {
          "id": "strap_part",
          "name": "Trapezoid Ribbon Strap",
          "groupId": 0,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Trapezoidal Strap"
    }
  ]
};
